"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DESCRIPTION = exports.CONTENT_AREA = exports.CAPTION = exports.BUTTON = void 0;
const CONTENT_AREA = exports.CONTENT_AREA = 'vertical-video-layout-content-area';
const BUTTON = exports.BUTTON = 'vertical-video-layout-button';
const DESCRIPTION = exports.DESCRIPTION = 'vertical-video-layout-description';
const CAPTION = exports.CAPTION = 'vertical-video-layout-caption';
